// extracted by mini-css-extract-plugin
module.exports = {"OuterContainer":"SelectedBundlesList_OuterContainer__1LdqW"};